import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class AfeDataSharingService {
    private afeNumberSubject = new BehaviorSubject<string | null>(null);
    afeNumber: Observable<string | null> = this.afeNumberSubject.asObservable();
    
    setAfeNumber(afe: string): void {
        this.afeNumberSubject.next(afe);
    }

    getCurrentAfe(): string | null {
        return this.afeNumberSubject.value;
    }
}